var map = {
	"./其他.png": 1776,
	"./其它平台.jpg": 6810,
	"./冷链.png": 4824,
	"./冷链运输平台.jpg": 8512,
	"./制造与商贸企业平台.jpg": 7480,
	"./协会.png": 9796,
	"./危化.png": 5598,
	"./危化运输平台.jpg": 6947,
	"./商砼.png": 267,
	"./商砼运输平台.jpg": 310,
	"./商贸.png": 3891,
	"./家具.png": 7954,
	"./家具配送平台.png": 3105,
	"./普货运输.png": 3790,
	"./物流.png": 9764,
	"./物流承运商平台.jpg": 3642,
	"./行业协会平台.jpg": 3530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9608;